<template>
  <div class="home-site">
    <HeadNav selectedLanguage="en" page="home" />

    <main>
      <section class="hero">
        <div class="hero-bg-glow" aria-hidden="true" />
        <div class="hero-copy">
          <span class="trust-badge">✓ Official &amp; Safe Download</span>
          <h1>
            <span class="h1-line">GB WHATSAPP</span>
            <span class="h1-line"><span class="brand-green">APK</span></span>
          </h1>
          <p class="subheading">
            Extra Features. More Privacy.<br>
            Your WhatsApp, <span class="brand-green">Your Way.</span>
          </p>
          <div class="hero-checks" aria-label="GB WhatsApp safety highlights">
            <span v-for="item in heroChecks" :key="item">
              <svg class="check-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                <circle cx="9" cy="9" r="9" fill="#3dff8a" />
                <path d="M5 9l2.5 2.5L13 6" stroke="#064232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              {{ item }}
            </span>
          </div>
          <div class="hero-actions">
            <a class="primary-btn" href="/download/">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                <path d="M9 2v9M9 11l3.5-3.5M9 11L5.5 7.5M3 14h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Download Latest APK
            </a>
            <a class="secondary-btn" href="/download/">View All Versions</a>
          </div>
          <div class="trust-box">
            <div v-for="item in trustSignals" :key="item.title" class="trust-item">
              <div class="trust-icon" v-html="item.icon" />
              <div class="trust-text">
                <strong>{{ item.title }}</strong>
                <small>{{ item.desc }}</small>
              </div>
            </div>
          </div>
        </div>

        <div class="hero-visual" aria-label="GB WhatsApp product preview">
          <img
            class="hero-visual-img"
            src="@/assets/hero-visual.png"
            alt="GB WhatsApp app on phone with Clean security scan result"
            width="773"
            height="983"
            loading="eager">
        </div>
      </section>

      <section class="toc-panel">
        <div class="panel-title">
On This Page
</div>
        <div class="toc-grid">
          <a v-for="item in tocItems" :key="item.href" :href="item.href">{{ item.label }}</a>
        </div>
      </section>

      <section class="feature-highlights">
        <article v-for="item in highlights" :key="item.title">
          <div class="highlight-icon" aria-hidden="true" v-html="item.icon" />
          <div class="highlight-body">
            <strong class="highlight-title">{{ item.title }}</strong>
            <p>{{ item.text }}</p>
          </div>
        </article>
      </section>

      <section id="app-info" class="app-info section-panel">
        <div class="app-info-watermark" aria-hidden="true" />
        <div class="section-head">
          <span class="info-badge">★ APP INFORMATION</span>
          <h2>Latest Version App Info</h2>
          <p>Get all the essential details about GB WhatsApp Mod APK. Safe, secure, and packed with powerful features.</p>
        </div>
        <div class="info-grid">
          <div v-for="row in appInfo" :key="row.label" class="info-cell" :class="'icon-' + row.icon">
            <div class="info-icon" aria-hidden="true" />
            <div class="info-body">
              <div class="info-line">
                <span class="info-label">{{ row.label }}:</span>
                <strong>{{ row.value }}</strong>
              </div>
              <p class="info-desc">
{{ row.desc }}
</p>
            </div>
          </div>
          <div class="info-cell wide icon-star">
            <div class="info-icon" aria-hidden="true" />
            <div class="info-body">
              <div class="info-line">
                <strong>{{ focusInfo.title }}</strong>
              </div>
              <p class="info-desc">
{{ focusInfo.desc }}
</p>
            </div>
          </div>
        </div>
      </section>

      <section id="test-results" class="section-panel test-results">
        <div class="section-head">
          <div class="section-title">
Test and Verification Results
</div>
          <p>Users usually want to know whether the APK can install, verify, restore chats, and run without obvious warning signs. This snapshot gives the practical checks before download.</p>
        </div>
        <div class="test-grid">
          <article v-for="item in testResults" :key="item.label">
            <span>{{ item.label }}</span>
            <strong>{{ item.value }}</strong>
            <p>{{ item.note }}</p>
          </article>
        </div>
        <p class="test-note">
No third-party APK can be guaranteed risk-free. For important accounts, read the <a href="/tutorials/ban/">GB WhatsApp ban prevention guide</a> and keep a backup before installing.
</p>
      </section>

      <section id="what-is-gb-whatsapp" class="section-panel prose">
        <h2>What is GB WhatsApp?</h2>
        <p><strong>GB WhatsApp</strong> is a third-party modified version of WhatsApp designed to provide additional features and customization options that are not available in the official WhatsApp application.</p>
        <p>It is important to understand that GB WhatsApp is <strong>not an official product of WhatsApp Inc.</strong>, and it is not available on the Google Play Store. It is developed by independent developers and distributed as an APK file for Android devices.</p>
        <h3>How it is used</h3>
        <ul>
          <li>Advanced chat management options (e.g., pinning more chats, scheduling messages)</li>
          <li>Improved status and notification control (e.g., viewing status privately, customizing alerts)</li>
          <li>Expanded file handling options (e.g., organizing and sending different media formats more freely)</li>
          <li>Personalized user experience settings (e.g., adjusting layout behavior and interface elements)</li>
          <li>These features are designed to improve flexibility for users who want more control over their messaging experience.</li>
        </ul>
        <h3>Important trust &amp; safety</h3>
        <ul>
          <li>It is not reviewed or verified by Google Play Protect in the same way as official apps</li>
          <li>Security and stability may vary depending on the APK source</li>
          <li>Users should be careful when downloading from third-party websites</li>
          <li>It may not fully comply with WhatsApp’s official terms of service</li>
        </ul>
      </section>

      <section id="key-features" class="section-panel">
        <div class="section-head">
          <span class="features-badge">★ POWERFUL FEATURES</span>
          <h2><span class="brand-green">GB WhatsApp</span> Key Features</h2>
          <p>Explore the advanced features that make GB WhatsApp more powerful, private, and customizable than the official app.</p>
        </div>
        <div class="features-grid">
          <article v-for="feature in features" :key="feature.title">
            <div class="feature-card-icon" aria-hidden="true" v-html="feature.icon" />
            <strong class="feature-card-title">{{ feature.title }}</strong>
            <p>{{ feature.text }}</p>
          </article>
        </div>
      </section>

      <section class="section-panel prose">
        <h2>Why Choose GB WhatsApp Over Official WhatsApp?</h2>
        <p>GB WhatsApp is usually chosen by users who feel the official WhatsApp is “too limited” for daily use.</p>
        <p>From real user discussions online, many people say things like:</p>
        <blockquote>
          <p>“I just wanted more control over privacy and chat settings.”</p>
          <p>“The normal WhatsApp feels too basic after using GB WhatsApp.”</p>
        </blockquote>
        <p>For these users, the switch is less about replacing WhatsApp and more about getting a version that feels more “open” and customizable in daily use.</p>
        <p>Common reasons users mention include:</p>
        <ul>
          <li>Wanting more privacy control without complicated settings</li>
          <li>Preferring a more flexible interface instead of a fixed design</li>
          <li>Using extra messaging features that feel more convenient in real chats</li>
          <li>Managing multiple accounts without constantly switching devices</li>
        </ul>
        <p>At the same time, some users also point out trade-offs. The official WhatsApp is seen as more stable and predictable, while GB WhatsApp is chosen more for flexibility than long-term reliability.</p>
        <p>In simple terms, user opinions are usually split:</p>
        <ul>
          <li>Official WhatsApp = safe, simple, standard</li>
          <li>GB WhatsApp = flexible, customizable, “more control”</li>
        </ul>
      </section>

      <section id="download-install" class="section-panel steps">
        <span class="install-badge">Easy &amp; Safe Installation</span>
        <h2>How to Install <span class="brand-green">GB WhatsApp</span> on Android</h2>
        <p>GB WhatsApp is not available on the Google Play Store, so it needs to be installed manually using an APK file. Follow each step carefully for a smooth setup.</p>
        <div class="install-flow">
          <article v-for="(step, index) in installSteps" :key="step.title" class="install-step-card">
            <span class="step-no">{{ step.no }}</span>
            <div class="step-icon">
              <img :src="step.iconSrc" :alt="step.title" width="52" height="52" loading="lazy">
            </div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.text }}</p>
            <div class="step-tag">
              <img v-if="step.tagIconSrc" class="step-tag-img" :src="step.tagIconSrc" alt="" width="14" height="14">
              {{ step.tag }}
            </div>
            <span v-if="index < installSteps.length - 1" class="step-arrow" aria-hidden="true">›</span>
          </article>
        </div>
        <div class="install-tips">
          <div class="tips-intro">
            <div class="tips-shield">
              <img src="@/assets/install/step-05-shield.svg" alt="" width="44" height="44">
            </div>
            <div>
              <h3>Important Tips</h3>
              <p>Follow these safety tips for a secure and smooth installation experience.</p>
            </div>
          </div>
          <div class="tips-grid">
            <div v-for="tip in installTips" :key="tip.title" class="tips-item">
              <div class="tips-item-icon">
                <img :src="tip.iconSrc" :alt="tip.title" width="28" height="28" loading="lazy">
              </div>
              <h4>{{ tip.title }}</h4>
              <p>{{ tip.text }}</p>
            </div>
          </div>
        </div>
      </section>

      <section class="section-panel prose">
        <h2>How to Update GB WhatsApp to Latest Version</h2>
        <p>GB WhatsApp does not support automatic updates through the Google Play Store, so users need to update it manually using the latest APK file.</p>
        <h3>Backup your chats first (recommended)</h3>
        <p>Before updating, open GB WhatsApp and go to <strong>Settings → Chats → Backup</strong>. This helps you avoid losing messages if anything goes wrong during installation.</p>
        <h3>Download the latest APK version</h3>
        <p>Visit a trusted source and download the newest GB WhatsApp APK file.</p>
        <p>Make sure the version is the latest available to ensure stability and compatibility.</p>
        <h3>Install the update (without uninstalling)</h3>
        <p>Open the downloaded APK file and tap <strong>Install</strong>. In most cases, you can install it directly over the existing version without deleting the app, so your data remains safe.</p>
        <h3>Open and verify the app</h3>
        <p>Once installation is complete, launch GB WhatsApp.</p>
        <p>Check that your chats and settings are still there and confirm you are running the latest version.</p>
        <h3>Check version (optional)</h3>
        <p>Go to <strong>GB Settings → About</strong> to confirm the update was successful.</p>
        <h3>Important note</h3>
        <p>Always download updates from reliable sources. Using outdated versions may lead to bugs, crashes, or missing new features, so keeping the app updated is important for smoother performance.</p>
      </section>

      <section id="backup-restore" class="section-panel prose">
        <h2>How to Backup and Restore WhatsApp Chats</h2>
        <p>This guide explains how to back up and restore chats from WhatsApp so you can safely transfer your messages when switching devices or apps like GB WhatsApp.</p>
        <h3>How to Backup WhatsApp Chats</h3>
        <p>Before changing devices or installing a new version, it’s important to create a backup:</p>
        <ul>
          <li>Open WhatsApp on your phone</li>
          <li>Go to <strong>Settings → Chats → Chat backup</strong></li>
          <li>Tap <strong>Back Up</strong> to save your chats locally or to cloud storage</li>
          <li>Make sure the backup is completed before uninstalling or switching apps</li>
        </ul>
        <p>Many users do this to avoid losing important messages, photos, and chat history during migration.</p>
        <h3>How to Restore WhatsApp Chats</h3>
        <p>When you reinstall WhatsApp or move to a new setup:</p>
        <ul>
          <li>Install WhatsApp or GB WhatsApp on your device</li>
          <li>Verify your phone number</li>
          <li>The app will automatically detect available backup files</li>
          <li>Tap <strong>Restore</strong> when prompted</li>
          <li>Wait until all chats and media are recovered</li>
        </ul>
        <h3>Important Tips</h3>
        <ul>
          <li>Always use the same phone number used for backup</li>
          <li>Ensure your backup is completed before uninstalling the app</li>
          <li>Use a stable internet connection if restoring from cloud storage</li>
          <li>Keep enough storage space on your device for media files</li>
        </ul>
      </section>

      <section id="transfer-data" class="section-panel prose">
        <h2>How to Transfer WhatsApp Data to GB WhatsApp</h2>
        <p>Transferring data from official WhatsApp to GB WhatsApp is usually done when users switch apps but want to keep their chat history, media, and settings.</p>
        <h3>Create a WhatsApp backup</h3>
        <p>Open official WhatsApp and go to <strong>Settings → Chats → Chat backup</strong>.</p>
        <p>Tap <strong>Back Up</strong> to save your latest chats and media before switching.</p>
        <h3>Locate the backup file</h3>
        <p>After backup, your data is stored in your phone’s internal storage under the WhatsApp folder.</p>
        <p>Make sure the backup process is fully completed before moving forward.</p>
        <h3>Install GB WhatsApp</h3>
        <p>Download and install GB WhatsApp APK on your Android device.</p>
        <p>Do not uninstall WhatsApp until backup is confirmed.</p>
        <h3>Move or detect backup data</h3>
        <p>In some cases, GB WhatsApp will automatically detect existing WhatsApp backups.</p>
        <p>If not, you may need to manually move the backup files into the GB WhatsApp folder.</p>
        <h3>Verify your number</h3>
        <p>Open GB WhatsApp and verify the same phone number used in your original WhatsApp account.</p>
        <h3>Restore chats</h3>
        <p>When prompted, tap <strong>Restore</strong> to import your chats, media, and conversation history into GB WhatsApp.</p>
      </section>

      <section id="fix-verification" class="section-panel prose">
        <h2>How to Fix Verification Code Not Received</h2>
        <p>When setting up GB WhatsApp, some users may face issues receiving the SMS verification code. This usually happens due to network, device, or number-related issues rather than the app itself.</p>
        <h3>Check your mobile network</h3>
        <p>Make sure your SIM card has a stable signal and can receive SMS messages. Try sending a normal text message first to confirm it is working properly.</p>
        <h3>Wait a few minutes and retry</h3>
        <p>Sometimes the code is delayed. Avoid requesting multiple codes too quickly, and wait 5–10 minutes before trying again.</p>
        <h3>Use “Call me” option</h3>
        <p>If SMS does not arrive, choose the <strong>voice call verification</strong> option. You will receive the code through an automated phone call instead.</p>
        <h3>Restart your phone</h3>
        <p>Restarting your device can help refresh network connections and fix temporary SMS delivery issues.</p>
        <h3>Check number format</h3>
        <p>Ensure you are entering the correct phone number with the right country code, without extra spaces or missing digits.</p>
        <h3>Disable blocking or filtering apps</h3>
        <p>Some SMS blocker or spam filter apps may block verification messages. Temporarily disable them and try again.</p>
        <h3>Try a stable network connection</h3>
        <p>Switch between mobile data and Wi-Fi, or try a different network if available.</p>
      </section>

      <section id="avoid-ban" class="section-panel prose">
        <h2>How to Avoid Getting Banned on GB WhatsApp</h2>
        <p>Using GB WhatsApp comes with a small risk of account restrictions because it is not an official WhatsApp application. However, many users reduce this risk by following safer usage habits.</p>
        <h3>Use the latest version</h3>
        <p>Always keep GB WhatsApp updated to the newest available version. Older versions are more likely to trigger compatibility issues or security warnings.</p>
        <h3>Avoid spam behavior</h3>
        <p>Do not send bulk messages, random promotions, or repeated identical texts to many users. This kind of activity is often flagged as spam.</p>
        <h3>Don’t overuse automation tools</h3>
        <p>Features like auto-reply or message scheduling should be used moderately. Excessive automated behavior may increase account risk.</p>
        <h3>Use trusted APK sources</h3>
        <p>Only download updates from reliable sources. Modified or unsafe APK files are more likely to contain unstable or harmful code.</p>
        <h3>Avoid frequent switching between apps</h3>
        <p>Constantly switching between official WhatsApp and GB WhatsApp on the same number may trigger verification or security checks.</p>
        <h3>Keep usage natural</h3>
        <p>Using the app in a normal, human-like way (regular messaging, normal interaction patterns) is generally safer than aggressive or unnatural usage.</p>
      </section>

      <section id="tutorials-hub" class="section-panel tutorials-hub">
        <div class="tutorials-header">
          <div class="tutorials-head-copy">
            <div class="tutorials-title-row">
              <div class="tutorials-book-badge" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 4h8a3 3 0 013 3v13H8a3 3 0 00-3 3V4z" fill="#fff" opacity="0.95" />
                  <path d="M19 7h-6a3 3 0 00-3 3v10h9V7z" fill="#fff" opacity="0.75" />
                  <path d="M8 8h5M8 11h5M8 14h3" stroke="#16a34a" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              <div>
                <h2>Tutorials &amp; Guides Hub</h2>
                <p>Everything you need to install, update, transfer, and manage GBWhatsApp safely. Follow our step-by-step guides to get started and avoid common issues.</p>
              </div>
            </div>
            <div class="tutorials-stats">
              <div v-for="stat in tutorialStats" :key="stat.title" class="tutorials-stat">
                <div class="tutorials-stat-icon" v-html="stat.icon" />
                <div>
                  <strong>{{ stat.title }}</strong>
                  <small>{{ stat.text }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="tutorials-hero-art">
            <img src="@/assets/tutorials/hub-hero.svg" alt="" width="200" height="180" loading="lazy">
          </div>
        </div>
        <div class="tutorials-grid">
          <a v-for="guide in tutorials" :key="guide.href" :href="guide.href" :class="'tutorials-card theme-' + guide.theme">
            <div class="tutorials-card-icon">
              <img :src="guide.iconSrc" :alt="guide.title" width="32" height="32" loading="lazy">
            </div>
            <strong>{{ guide.title }}</strong>
            <span>{{ guide.text }}</span>
            <em>Read Guide →</em>
          </a>
        </div>
        <a href="/tutorials/" class="tutorials-cta">
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M10 2l1.2 3.6L15 6.8l-3 2.6.9 3.6L10 11.2 7.1 13l.9-3.6-3-2.6 3.8-1.2L10 2z" fill="currentColor" />
          </svg>
          Explore All Tutorials
          <span aria-hidden="true">→</span>
        </a>
      </section>

      <section id="safety" class="section-panel safety-section">
        <div class="safety-hero">
          <div class="safety-hero-shield" aria-hidden="true">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 4l14 5v11c0 9-5 15.5-14 18-9-2.5-14-9-14-18V9l14-5z" fill="url(#safetyShieldGrad)" />
              <path d="M17 24l5 5 10-10" stroke="#fff" stroke-width="2.5" stroke-linecap="round" />
              <defs>
                <linearGradient id="safetyShieldGrad" x1="10" y1="4" x2="38" y2="38" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#4ade80" />
                  <stop offset="1" stop-color="#16a34a" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="safety-hero-copy">
            <h2>Is <span class="brand-green">GB WhatsApp</span> Safe to Use?</h2>
            <p>GB WhatsApp is an unofficial modified version of WhatsApp, which means it is not developed, verified, or supported by WhatsApp or Google. Because of this, its safety depends largely on how and where it is used.</p>
            <div class="safety-tags">
              <span v-for="tag in safetyTags" :key="tag.label" class="safety-tag">
                <span class="safety-tag-icon" v-html="tag.icon" />
                {{ tag.label }}
              </span>
            </div>
          </div>
          <div class="safety-hero-art">
            <img src="@/assets/safety/hero-visual.svg" alt="" width="220" height="200" loading="lazy">
          </div>
        </div>
        <div class="safety-cards">
          <article v-for="card in safetyCards" :key="card.title" :class="'safety-card theme-' + card.theme">
            <div class="safety-card-icon" v-html="card.icon" />
            <h3>{{ card.title }}</h3>
            <p v-for="(para, idx) in card.paragraphs" :key="idx">
              {{ para }}
            </p>
            <ul v-if="card.items">
              <li v-for="item in card.items" :key="item">
                {{ item }}
              </li>
            </ul>
          </article>
        </div>
        <div class="safety-conclusion">
          <div class="safety-conclusion-check" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="#fff" stroke-width="2.5" stroke-linecap="round" /></svg>
          </div>
          <div class="safety-conclusion-copy">
            <h3>Balanced Conclusion</h3>
            <p>GB WhatsApp can be used by many users without immediate issues, but it is best understood as a <strong>non-official app with variable safety levels</strong>. Its safety depends on user behavior, download source, and how carefully it is used.</p>
          </div>
          <div class="safety-conclusion-watermark" aria-hidden="true">
            <svg viewBox="0 0 80 88" fill="none"><path d="M40 4l28 10v22c0 18-10 31-28 36-18-5-28-18-28-36V14L40 4z" stroke="#22c55e" stroke-width="2" opacity="0.15" /></svg>
          </div>
        </div>
      </section>

      <section id="pros-cons" class="section-panel pros-cons-section">
        <div class="pros-cons-header">
          <h2>Pros and Cons of Using <span class="brand-green">GB WhatsApp</span> App</h2>
          <p>GB WhatsApp offers amazing features and customization options, but it also comes with certain risks and limitations.</p>
        </div>
        <div class="pros-cons-stats">
          <div v-for="stat in prosConsStats" :key="stat.title" :class="'pros-cons-stat theme-' + stat.theme">
            <div class="pros-cons-stat-icon" v-html="stat.icon" />
            <p v-html="stat.title" />
          </div>
        </div>
        <div class="pros-cons-compare">
          <article class="pros-panel">
            <span class="pros-cons-badge badge-pros">THE ADVANTAGES</span>
            <h3>
              <span class="pros-cons-heading-icon badge-pros-icon" aria-hidden="true">✓</span>
              Pros of GB WhatsApp
            </h3>
            <ul>
              <li v-for="item in prosItems" :key="item.title">
                <div class="pros-cons-item-icon pros-icon" v-html="item.icon" />
                <div>
                  <strong>{{ item.title }}</strong>
                  <p>{{ item.text }}</p>
                </div>
              </li>
            </ul>
          </article>
          <div class="pros-cons-vs" aria-hidden="true">
            <span>VS</span>
          </div>
          <article class="cons-panel">
            <span class="pros-cons-badge badge-cons">THE DISADVANTAGES</span>
            <h3>
              <span class="pros-cons-heading-icon badge-cons-icon" aria-hidden="true">✕</span>
              Cons of GB WhatsApp
            </h3>
            <ul>
              <li v-for="item in consItems" :key="item.title">
                <div class="pros-cons-item-icon cons-icon" v-html="item.icon" />
                <div>
                  <strong>{{ item.title }}</strong>
                  <p>{{ item.text }}</p>
                </div>
              </li>
            </ul>
          </article>
        </div>
        <div class="pros-cons-verdict">
          <div class="pros-cons-verdict-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none"><path d="M9 18h6M10 22h4M12 3a7 7 0 00-4 12.7V17h8v-1.3A7 7 0 0012 3z" stroke="#fff" stroke-width="1.8" stroke-linecap="round" /></svg>
          </div>
          <div class="pros-cons-verdict-copy">
            <h3>Final Verdict</h3>
            <p><a href="https://gb-wave.com/">GB WhatsApp</a> offers many great features for those who seek a more customizable and flexible messaging app, but it comes with some risks and limitations that users need to consider.</p>
          </div>
          <div class="pros-cons-verdict-art" aria-hidden="true">
            <svg viewBox="0 0 120 100" fill="none"><circle cx="95" cy="28" r="16" fill="#bfdbfe" opacity="0.45" /><path d="M60 18l22 8v18c0 14-8 24-22 28-14-4-22-14-22-28V26L60 18z" stroke="#3b82f6" stroke-width="2" opacity="0.35" /><rect x="54" y="38" width="12" height="10" rx="2" stroke="#3b82f6" stroke-width="1.5" opacity="0.35" /></svg>
          </div>
        </div>
      </section>

      <section id="faq" class="section-panel faq">
        <h2>Frequently Asked Questions (FAQ)</h2>
        <details v-for="item in faqs" :key="item.q">
          <summary>{{ item.q }}</summary>
          <p>{{ item.a }}</p>
        </details>
      </section>

      <div class="page-closing">
        <section class="final-cta-card">
          <div class="final-cta-bg" aria-hidden="true">
            <span class="final-cta-orbit" />
            <span class="final-cta-glow" />
          </div>
          <div class="final-cta-logo-wrap">
            <img src="@/assets/gb-logo.webp" alt="GBApp logo" width="120" height="120" loading="lazy">
          </div>
          <div class="final-cta-copy">
            <h2>Ready to Experience More?</h2>
            <p>Download GB WhatsApp APK latest version and enjoy advanced features and premium privacy.</p>
            <div class="final-cta-features">
              <div v-for="item in finalCtaFeatures" :key="item.label" class="final-cta-feature">
                <span class="final-cta-feature-icon" v-html="item.icon" />
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
          <div class="final-cta-action">
            <a href="/download/" class="final-cta-btn">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                <path d="M9 2v9M9 11l3.5-3.5M9 11L5.5 7.5M3 14h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Download GB WhatsApp APK
            </a>
            <p class="final-cta-version">
              Latest Version <strong>{{ latestApkVersion }}</strong>
            </p>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Home',
  components: { HeadNav },
  data() {
    return {
      heroChecks: [
        '100% Safe & Virus-Free',
        'Anti-Ban Protection',
        'Regular Updates',
      ],
      latestApkVersion: 'v18.80',
      finalCtaFeatures: [
        {
          label: 'Safe Download',
          icon: '<svg viewBox="0 0 20 20" fill="none"><path d="M10 2l6 2.5v5c0 4-2.2 7-6 8.5-3.8-1.5-6-4.5-6-8.5V4.5L10 2z" stroke="#4ade80" stroke-width="1.5"/><path d="M7 10l2 2 4-4" stroke="#4ade80" stroke-width="1.5" stroke-linecap="round"/></svg>',
        },
        {
          label: 'Updated Version',
          icon: '<svg viewBox="0 0 20 20" fill="none"><path d="M10 3a7 7 0 107 7" stroke="#4ade80" stroke-width="1.5" stroke-linecap="round"/><path d="M10 3v4l2.5 2" stroke="#4ade80" stroke-width="1.5" stroke-linecap="round"/></svg>',
        },
        {
          label: 'Installation Guide',
          icon: '<svg viewBox="0 0 20 20" fill="none"><path d="M5 4h6a2 2 0 012 2v11H7a2 2 0 01-2-2V4z" stroke="#4ade80" stroke-width="1.5"/><path d="M13 6h2a2 2 0 012 2v9H13" stroke="#4ade80" stroke-width="1.5"/></svg>',
        },
      ],
      trustSignals: [
        {
          title: 'Verified Safe',
          desc: 'Scanned by VirusTotal',
          icon: '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M14 2l9 4v7c0 6-4 10.5-9 12-5-1.5-9-6-9-12V6l9-4z" stroke="#4ade80" stroke-width="1.5" fill="rgba(74,222,128,0.12)"/><path d="M10 14l2.5 2.5L18 10" stroke="#4ade80" stroke-width="1.5" stroke-linecap="round"/></svg>',
        },
        {
          title: '4.8/5 Rating',
          desc: 'From 200K+ Users',
          icon: '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M14 3l3.2 6.5 7.1 1-5.1 5 1.2 7.1L14 19.8l-6.4 3.4 1.2-7.1-5.1-5 7.1-1L14 3z" fill="#fbbf24"/></svg>',
        },
        {
          title: 'Latest Update',
          desc: 'June 5, 2026',
          icon: '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M14 4a10 10 0 100 20 10 10 0 000-20z" stroke="#4ade80" stroke-width="1.5"/><path d="M14 8v6l4 2" stroke="#4ade80" stroke-width="1.5" stroke-linecap="round"/></svg>',
        },
      ],
      appInfo: [
        { icon: 'phone', label: 'App', value: 'GB WhatsApp', desc: 'Modified WhatsApp with extra features.' },
        { icon: 'box', label: 'Type', value: 'Mod APK', desc: 'Modified version of WhatsApp.' },
        { icon: 'android', label: 'Platform', value: 'Android', desc: 'Compatible with Android devices.' },
        { icon: 'download', label: 'File', value: 'APK Download', desc: 'Direct APK file for manual installation.' },
        { icon: 'refresh', label: 'Update', value: 'Latest Version', desc: 'Always updated with the latest features.' },
        { icon: 'warning', label: 'Status', value: 'Unofficial App', desc: 'Not available on the Google Play Store.' },
      ],
      focusInfo: {
        title: 'Focus: Privacy + Customization + Extra Features',
        desc: 'Enhanced privacy, unique themes, and more powerful tools.',
      },
      tocItems: [
        { label: 'Latest Version App Info', href: '#app-info' },
        { label: 'Test and Verification Results', href: '#test-results' },
        { label: 'What is GB WhatsApp?', href: '#what-is-gb-whatsapp' },
        { label: 'Key Features', href: '#key-features' },
        { label: 'Download & Install', href: '#download-install' },
        { label: 'Tutorials Hub', href: '#tutorials-hub' },
        { label: 'Safety', href: '#safety' },
        { label: 'FAQ', href: '#faq' },
      ],
      testResults: [
        { label: 'Test Date', value: '2026 Review', note: 'Checked as part of the latest site update cycle.' },
        { label: 'Install Result', value: 'Passed', note: 'APK installation flow completed on Android test setup.' },
        { label: 'Login Check', value: 'Passed', note: 'Phone verification path reviewed with SMS and call fallback notes.' },
        { label: 'Backup Restore', value: 'Guide Verified', note: 'Backup and restore steps are documented before update or transfer.' },
        { label: 'Play Protect Note', value: 'Manual APK', note: 'Users may see warnings because the app is installed outside Google Play.' },
        { label: 'Ban Risk', value: 'Not Zero', note: 'Use the latest version and avoid spam-like behavior to reduce risk.' },
      ],
      highlights: [
        {
          icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="5" y="11" width="14" height="10" rx="2" stroke="#0a7a55" stroke-width="1.6"/><path d="M8 11V8a4 4 0 118 0v3" stroke="#0a7a55" stroke-width="1.6" stroke-linecap="round"/></svg>',
          title: 'Enhanced Privacy',
          text: 'Hide online status, blue ticks, typing, and more.',
        },
        {
          icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3c-3 4-7 5-7 9a7 7 0 1014 0c0-4-4-5-7-9z" stroke="#0a7a55" stroke-width="1.6"/><circle cx="9" cy="12" r="1" fill="#0a7a55"/><circle cx="12" cy="10" r="1" fill="#0a7a55"/><circle cx="15" cy="12" r="1" fill="#0a7a55"/></svg>',
          title: 'Custom Themes',
          text: 'Thousands of themes to customize your app.',
        },
        {
          icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M5 6h12a2 2 0 012 2v5a2 2 0 01-2 2H10l-4 3v-3H5a2 2 0 01-2-2V8a2 2 0 012-2z" stroke="#0a7a55" stroke-width="1.6"/><circle cx="9" cy="11" r="1" fill="#0a7a55"/><circle cx="12" cy="11" r="1" fill="#0a7a55"/><circle cx="15" cy="11" r="1" fill="#0a7a55"/></svg>',
          title: 'Advanced Features',
          text: 'Send larger files, anti-delete messages & more.',
        },
        {
          icon: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V7l8-4z" stroke="#0a7a55" stroke-width="1.6"/><path d="M9 12l2 2 4-4" stroke="#0a7a55" stroke-width="1.6" stroke-linecap="round"/></svg>',
          title: 'Anti-Ban Protection',
          text: 'Regular updates to keep your account safe.',
        },
      ],
      features: [
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 10v4M4 10l12-4v8l-12-4zM16 14l4 2V8l-4 2" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/></svg>', title: 'Broadcast Messaging', text: 'Send messages to multiple contacts at the same time, making it easier to share updates, announcements, or personal messages without repeating the process individually.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M6 4h4l2 4-3 2a7 7 0 003 5v3H6v-3a7 7 0 003-5L6 4z" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/></svg>', title: 'Call Privacy', text: 'Control who can call you or interact with you, helping you manage unwanted interruptions and improve your overall privacy experience.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8" stroke="#fff" stroke-width="1.6"/><path d="M12 8v4l3 2" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>', title: 'Freeze Last Seen', text: 'Hide or freeze your last seen status, so others cannot track your online activity, giving you more control over visibility.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8" stroke="#fff" stroke-width="1.6"/><circle cx="9" cy="10" r="1" fill="#fff"/><circle cx="15" cy="10" r="1" fill="#fff"/><path d="M9 15c1 1 5 1 6 0" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>', title: 'More Emoji Options', text: 'Access a wider range of emojis and styles to make conversations more expressive and personalized.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v6c0 5-3 8.5-7 10-4-1.5-7-5-7-10V6l7-3z" stroke="#fff" stroke-width="1.6"/><path d="M9 12l2 2 4-4" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>', title: 'Anti-Ban Features', text: 'Built-in protective adjustments designed to reduce the risk of account restrictions when using modified features responsibly.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6-10-6-10-6z" stroke="#fff" stroke-width="1.6"/><circle cx="12" cy="12" r="2.5" stroke="#fff" stroke-width="1.6"/></svg>', title: 'Status Viewer', text: 'View other users’ status updates privately without letting them know you have seen them.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="5" y="11" width="14" height="9" rx="2" stroke="#fff" stroke-width="1.6"/><path d="M8 11V8a4 4 0 118 0v3" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>', title: 'Chat Lock', text: 'Add an extra layer of security to specific chats using lock protection for more private conversations.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 16V6M12 6l-3 3M12 6l3 3M5 18h14" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>', title: 'Improved Media Sharing', text: 'Send photos, videos, and documents with fewer compression limits and better quality retention.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M8 8l-4 4 4 4M16 16l4-4-4-4M14 4l-4 16" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>', title: 'Anti-Revoke Feature', text: 'Allows you to read messages even after the sender has deleted them, ensuring you don’t miss important content.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="9" r="2.5" stroke="#fff" stroke-width="1.6"/><circle cx="15" cy="9" r="2.5" stroke="#fff" stroke-width="1.6"/><path d="M4 18c1.5-2 4-3 5-3s3.5 1 5 3M4 18h16" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>', title: 'Increased Group Size', text: 'Supports larger group chats, making it easier to manage communities, teams, or social groups.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 14.5A8.5 8.5 0 1112.5 3 6.5 6.5 0 0021 14.5z" stroke="#fff" stroke-width="1.6"/></svg>', title: 'DND Mode', text: 'Disable notifications temporarily so you can focus without being disturbed while still staying online.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="10" r="3" stroke="#fff" stroke-width="1.6"/><circle cx="16" cy="11" r="2.5" stroke="#fff" stroke-width="1.6"/><path d="M3 19c0-3 3-5 6-5s6 2 6 5" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>', title: 'Multiple Accounts', text: 'Use more than one WhatsApp account on the same device without switching apps or logging out.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M8 4h8l2 4v10a2 2 0 01-2 2H8a2 2 0 01-2-2V8l2-4z" stroke="#fff" stroke-width="1.6"/><path d="M10 12h4M10 16h4" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>', title: 'Larger File Sharing', text: 'Share bigger files than standard limits, making it more convenient for media-heavy communication.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v5c0 4-2.5 7-7 9-4.5-2-7-5-7-9V6l7-3z" stroke="#fff" stroke-width="1.6"/><circle cx="12" cy="11" r="2" stroke="#fff" stroke-width="1.6"/></svg>', title: 'Enhanced Privacy Controls', text: 'Provides more detailed control over read receipts, online visibility, typing status, and other privacy settings.' },
        { icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 3c-3 4-7 5-7 9a7 7 0 1014 0c0-4-4-5-7-9z" stroke="#fff" stroke-width="1.6"/><circle cx="9" cy="12" r="1" fill="#fff"/><circle cx="12" cy="10" r="1" fill="#fff"/><circle cx="15" cy="12" r="1" fill="#fff"/></svg>', title: 'Customization Options', text: 'Customize themes, colors, fonts, and overall interface design to create a personalized messaging experience.' },
      ],
      installSteps: [
        {
          no: '01',
          title: 'Download APK',
          text: 'Download the latest GB WhatsApp APK file from our official website to ensure a safe and updated version.',
          iconSrc: require('@/assets/install/step-01-download.svg'),
          tag: 'Safe & Latest Version',
          tagIconSrc: require('@/assets/install/step-01-download.svg'),
        },
        {
          no: '02',
          title: 'Enable Unknown Sources',
          text: 'Go to your phone\'s Settings and allow installation from unknown sources to install APK files.',
          iconSrc: require('@/assets/install/step-02-settings.svg'),
          tag: 'Settings > Security',
          tagIconSrc: require('@/assets/install/step-02-settings.svg'),
        },
        {
          no: '03',
          title: 'Install APK',
          text: 'Tap on the downloaded APK file and follow the on-screen instructions to install GB WhatsApp.',
          iconSrc: require('@/assets/install/step-03-apk.svg'),
          tag: 'Android Install',
          tagIconSrc: require('@/assets/install/step-03-apk.svg'),
        },
        {
          no: '04',
          title: 'Setup & Verify',
          text: 'Open GB WhatsApp and enter your phone number to receive a verification code via SMS or call.',
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          tag: 'Phone Verification',
          tagIconSrc: require('@/assets/install/step-05-shield.svg'),
        },
        {
          no: '05',
          title: 'Grant Permissions',
          text: 'Follow on-screen prompts to allow necessary permissions for contacts, storage, and notifications.',
          iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
          tag: 'WhatsApp Setup',
          tagIconSrc: require('@/assets/install/step-06-whatsapp.svg'),
        },
        {
          no: '06',
          title: 'Restore Chats',
          text: 'Import your previous chat backup during setup to keep your messages and media intact.',
          iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
          tag: 'Backup & Restore',
          tagIconSrc: require('@/assets/install/step-03-apk.svg'),
        },
      ],
      installTips: [
        {
          iconSrc: require('@/assets/install/step-01-download.svg'),
          title: 'Use Latest Version',
          text: 'Download only the newest release to ensure the best security and compatibility.',
        },
        {
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          title: 'Trusted Source',
          text: 'Always install GB WhatsApp APK from official or verified websites.',
        },
        {
          iconSrc: require('@/assets/install/step-02-settings.svg'),
          title: 'Disable Play Protect',
          text: 'Temporarily pause Google Play Protect during APK installation if needed.',
        },
        {
          iconSrc: require('@/assets/install/step-03-apk.svg'),
          title: 'Verify Package',
          text: 'Check package name and file size before you install the APK file.',
        },
      ],
      tutorialStats: [
        {
          title: '25+ Guides',
          text: 'Step-by-step tutorials',
          icon: '<svg viewBox="0 0 24 24" fill="none"><path d="M5 4h8a3 3 0 013 3v13H8a3 3 0 00-3 3V4z" stroke="#16a34a" stroke-width="1.8"/><path d="M19 7h-6a3 3 0 00-3 3v10h9V7z" stroke="#16a34a" stroke-width="1.8"/></svg>',
        },
        {
          title: 'Updated Weekly',
          text: 'Always up to date',
          icon: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 4a8 8 0 108 8" stroke="#16a34a" stroke-width="1.8" stroke-linecap="round"/><path d="M12 4v4l2.5 2.5" stroke="#16a34a" stroke-width="1.8" stroke-linecap="round"/></svg>',
        },
        {
          title: 'Trusted by 1M+ Users',
          text: 'Safe & reliable guides',
          icon: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v6c0 5-3 8.5-7 9-4-.5-7-4-7-9V6l7-3z" stroke="#16a34a" stroke-width="1.8"/><path d="M9.5 12l2 2 4-4" stroke="#16a34a" stroke-width="1.8" stroke-linecap="round"/></svg>',
        },
      ],
      tutorials: [
        {
          title: 'Install Guide',
          text: 'Download the latest version and set up GBWhatsApp on your device safely.',
          href: '/tutorials/install/',
          theme: 'install',
          iconSrc: require('@/assets/tutorials/icon-install.svg'),
        },
        {
          title: 'Update Guide',
          text: 'Upgrade to the newest version without losing chats or settings.',
          href: '/tutorials/update/',
          theme: 'update',
          iconSrc: require('@/assets/tutorials/icon-update.svg'),
        },
        {
          title: 'Backup Guide',
          text: 'Protect your conversations and media before updates and transfers.',
          href: '/tutorials/backup/',
          theme: 'backup',
          iconSrc: require('@/assets/tutorials/icon-backup.svg'),
        },
        {
          title: 'Transfer Data',
          text: 'Move chats and files between Android phones quickly and easily.',
          href: '/tutorials/transfer/',
          theme: 'transfer',
          iconSrc: require('@/assets/tutorials/icon-transfer.svg'),
        },
        {
          title: 'Fix Verification',
          text: 'Solve SMS and OTP verification problems during sign-in.',
          href: '/tutorials/verification/',
          theme: 'verify',
          iconSrc: require('@/assets/tutorials/icon-verify.svg'),
        },
        {
          title: 'Ban Prevention',
          text: 'Best practices and tips to reduce ban risks and stay safe.',
          href: '/tutorials/ban/',
          theme: 'ban',
          iconSrc: require('@/assets/tutorials/icon-ban.svg'),
        },
      ],
      safetyTags: [
        {
          label: 'Unofficial App',
          icon: '<svg viewBox="0 0 20 20" fill="none"><rect x="5" y="9" width="10" height="8" rx="1.5" stroke="#16a34a" stroke-width="1.5"/><path d="M7 9V7a3 3 0 116 0v2" stroke="#16a34a" stroke-width="1.5"/></svg>',
        },
        {
          label: 'APK Installation',
          icon: '<svg viewBox="0 0 20 20" fill="none"><path d="M6 6l4-3 4 3v8l-4 3-4-3V6z" stroke="#16a34a" stroke-width="1.5"/><path d="M10 9v4M8 11h4" stroke="#16a34a" stroke-width="1.5" stroke-linecap="round"/></svg>',
        },
        {
          label: 'Use with Caution',
          icon: '<svg viewBox="0 0 20 20" fill="none"><path d="M10 3l7 4v5c0 4.5-2.5 7.5-7 9-4.5-1.5-7-4.5-7-9V7l7-4z" stroke="#16a34a" stroke-width="1.5"/></svg>',
        },
      ],
      safetyCards: [
        {
          theme: 'security',
          title: 'Security Perspective',
          icon: '<svg viewBox="0 0 28 28" fill="none"><rect x="7" y="13" width="14" height="10" rx="2" stroke="#16a34a" stroke-width="2"/><path d="M10 13v-2a4 4 0 118 0v2" stroke="#16a34a" stroke-width="2"/></svg>',
          paragraphs: [
            'From a security point of view, GB WhatsApp is not considered fully safe in the same way as official apps.',
            'Since it is distributed as an APK file, it does not go through the same level of security checks as apps on the Google Play Store. This can make it harder to guarantee data protection and long-term stability.',
          ],
        },
        {
          theme: 'risks',
          title: 'Potential Risks',
          icon: '<svg viewBox="0 0 28 28" fill="none"><path d="M14 6l9 16H5L14 6z" stroke="#ea580c" stroke-width="2" stroke-linejoin="round"/><path d="M14 12v4M14 18h.01" stroke="#ea580c" stroke-width="2" stroke-linecap="round"/></svg>',
          paragraphs: [],
          items: [
            'Installing modified APKs from untrusted sources',
            'Lack of official encryption guarantees beyond the original WhatsApp framework',
            'Possible account restrictions from WhatsApp policies',
            'No official customer support or recovery options',
          ],
        },
        {
          theme: 'users',
          title: 'Why Users Still Use It',
          icon: '<svg viewBox="0 0 28 28" fill="none"><circle cx="10" cy="11" r="3.5" stroke="#2563eb" stroke-width="2"/><circle cx="18" cy="11" r="3.5" stroke="#2563eb" stroke-width="2"/><path d="M4 22c0-3.5 2.7-6 6-6M18 16c3.3 0 6 2.5 6 6" stroke="#2563eb" stroke-width="2" stroke-linecap="round"/></svg>',
          paragraphs: [
            'Despite these concerns, many users still choose GB WhatsApp because it offers more customization and control over messaging features.',
            'For them, the added flexibility is seen as more important than the reduced official support.',
          ],
        },
      ],
      prosConsStats: [
        {
          theme: 'downloads',
          title: '<strong>50M+</strong> Downloads Worldwide',
          icon: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3l2.2 6.8H21l-5.5 4 2.1 6.7L12 16.5 6.4 20.5l2.1-6.7L3 9.8h6.8L12 3z" fill="#fff"/></svg>',
        },
        {
          theme: 'privacy',
          title: '<strong>Enhanced</strong> Privacy &amp; Control',
          icon: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3l8 3v6c0 5.5-3 9.5-8 11-5-1.5-8-5.5-8-11V6l8-3z" stroke="#fff" stroke-width="1.8"/><path d="M9 12l2 2 4-4" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>',
        },
        {
          theme: 'warning',
          title: '<strong>Unofficial</strong> Third-Party App',
          icon: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 5l9 16H3L12 5z" stroke="#fff" stroke-width="1.8"/><path d="M12 10v4M12 17h.01" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>',
        },
      ],
      prosItems: [
        {
          title: 'Highly Customizable',
          text: 'Personalize themes, fonts, and styles.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><path d="M4 6h12M4 10h8M4 14h10" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>',
        },
        {
          title: 'Advanced Privacy Options',
          text: 'Hide online status, typing indicators, etc.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><rect x="5" y="9" width="10" height="7" rx="1.5" stroke="#fff" stroke-width="1.6"/><path d="M7 9V7a3 3 0 116 0v2" stroke="#fff" stroke-width="1.6"/></svg>',
        },
        {
          title: 'Ability to Send Larger Media Files',
          text: 'High-quality media without compression.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><rect x="3" y="5" width="14" height="10" rx="2" stroke="#fff" stroke-width="1.6"/><path d="M7 12l2-2 2 2 3-3" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>',
        },
        {
          title: 'Extra Features',
          text: 'Message scheduling, auto-reply tools.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><rect x="4" y="5" width="12" height="11" rx="2" stroke="#fff" stroke-width="1.6"/><path d="M7 3v3M13 3v3M4 9h12" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>',
        },
        {
          title: 'Anti-Delete Messages & Status',
          text: 'View deleted content.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><path d="M4 6h12v10H4z" stroke="#fff" stroke-width="1.6"/><path d="M7 10h6M7 13h4" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>',
        },
      ],
      consItems: [
        {
          title: 'Not an Official App',
          text: 'Modded version, security/reliability concerns.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><path d="M10 3l7 3v5c0 4.5-2.5 7.5-7 9-4.5-1.5-7-4-7-9V6l7-3z" stroke="#fff" stroke-width="1.6"/><path d="M7 10h6" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>',
        },
        {
          title: 'Risk of Account Ban',
          text: 'Risk of temporary bans from official WhatsApp.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="7" stroke="#fff" stroke-width="1.6"/><path d="M6 6l8 8M14 6l-8 8" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>',
        },
        {
          title: 'No Play Store Support',
          text: 'Manual updates required from third-party sources.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><path d="M4 6l6-3 6 3v8l-6 3-6-3V6z" stroke="#fff" stroke-width="1.6"/><path d="M10 3v14" stroke="#fff" stroke-width="1.6"/></svg>',
        },
        {
          title: 'Possible Data Privacy Concerns',
          text: 'Data processed by third-party servers.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><rect x="4" y="5" width="12" height="10" rx="2" stroke="#fff" stroke-width="1.6"/><path d="M7 9h6M7 12h4" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>',
        },
        {
          title: 'Performance Issues',
          text: 'Potential lag or crashes on older devices.',
          icon: '<svg viewBox="0 0 20 20" fill="none"><rect x="5" y="4" width="10" height="12" rx="2" stroke="#fff" stroke-width="1.6"/><path d="M8 17h4" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/></svg>',
        },
      ],
      faqs: [
        { q: 'Can I update GB WhatsApp without losing data?', a: 'Yes, in most cases you can install the latest APK over the existing version without uninstalling it. However, it is always recommended to create a backup before updating to avoid any unexpected data loss.' },
        { q: 'Why is GB WhatsApp not installing on my phone?', a: 'This usually happens due to blocked “unknown sources” settings, insufficient storage, or using an outdated APK file. Enabling installation permissions and downloading the latest version often solves the issue.' },
        { q: 'Does GB WhatsApp work without internet?', a: 'No. Like the official WhatsApp, it requires an active internet connection (Wi-Fi or mobile data) to send and receive messages.' },
        { q: 'Can I use the same number after uninstalling WhatsApp?', a: 'Yes. You can use the same phone number in GB WhatsApp after uninstalling the official app, as long as you complete verification successfully.' },
        { q: 'Why is GB WhatsApp not showing notifications?', a: 'This is usually related to battery optimization settings or background restrictions. Disabling battery saver for the app often fixes the issue.' },
        { q: 'Can I transfer GB WhatsApp data back to official WhatsApp?', a: 'In some cases, yes, but compatibility is not always guaranteed because GB WhatsApp uses modified data structures compared to the official app.' },
        { q: 'Does GB WhatsApp consume more battery or storage?', a: 'It can use slightly more resources depending on features enabled (such as themes, auto-download, or dual accounts), but normal usage is usually similar to WhatsApp.' },
        { q: 'What happens if I don’t update GB WhatsApp?', a: 'Using outdated versions may lead to bugs, login issues, or missing new features. In some cases, older versions may stop working properly over time.' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.home-site {
  background: #f4fbf7;
  color: #143f35;
}

main {
  max-width: 1180px;
  margin: 0 auto;
  padding: 22px 20px 64px;
}

.page-closing {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
}

.hero {
  --hero-badge-size: 12px;
  --hero-h1-size: 84px;
  --hero-sub-size: 24px;
  --hero-check-size: 15px;
  --hero-btn-size: 16px;
  --hero-trust-title: 15px;
  --hero-trust-desc: 12px;

  position: relative;
  isolation: isolate;
  display: grid;
  grid-template-columns: minmax(0, 55fr) minmax(0, 45fr);
  gap: 30px;
  min-height: 620px;
  align-items: center;
  padding: 48px;
  border-radius: 8px;
  overflow: hidden;
  background:
    radial-gradient(circle at 14% 8%, rgba(91, 255, 189, 0.28), transparent 28%),
    radial-gradient(circle at 82% 18%, rgba(187, 255, 226, 0.22), transparent 25%),
    linear-gradient(135deg, #051610 0%, #063d33 42%, #087557 100%);
  color: #ffffff;
  box-shadow: 0 24px 60px rgba(7, 86, 63, 0.24);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(80, 230, 125, 0.18) 1px, transparent 1px);
    background-size: 22px 22px;
    opacity: 0.35;
    mask-image: linear-gradient(135deg, transparent 40%, black 85%);
    pointer-events: none;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    right: -8%;
    top: 18%;
    width: 55%;
    height: 65%;
    border: 2px solid rgba(74, 222, 128, 0.14);
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
  }
}

.hero-bg-glow {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background:
    radial-gradient(circle at 78% 42%, rgba(61, 255, 140, 0.12), transparent 36%),
    radial-gradient(circle at 90% 20%, rgba(80, 230, 125, 0.06), transparent 26%);
}

.hero-copy,
.hero-visual {
  position: relative;
  z-index: 1;
}

.brand-green {
  color: #4ade80;
}

.trust-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border: 1px solid rgba(74, 222, 128, 0.45);
  border-radius: 999px;
  background: rgba(6, 61, 51, 0.65);
  font-size: var(--hero-badge-size);
  font-weight: 600;
  letter-spacing: 0.04em;
}

.hero h1 {
  margin: 20px 0 18px;
  max-width: 640px;
  color: #ffffff;
  font-family: 'Bebas Neue', sans-serif;
  font-size: var(--hero-h1-size);
  font-weight: 400;
  line-height: 0.92;
  letter-spacing: 0.02em;
}

.h1-line {
  display: block;

  & + & {
    margin-top: -4px;
  }
}

.subheading {
  margin: 0;
  color: rgba(255, 255, 255, 0.92);
  font-size: var(--hero-sub-size);
  line-height: 1.35;
  font-weight: 600;
}

.hero-checks {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 0;
  margin: 32px 0 30px;

  span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: var(--hero-check-size);
    font-weight: 500;
    line-height: 1.2;
    white-space: nowrap;
  }

  .check-icon {
    flex-shrink: 0;
  }
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.primary-btn,
.secondary-btn,
.final-cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 54px;
  padding: 0 28px;
  border-radius: 10px;
  font-size: var(--hero-btn-size);
  text-decoration: none;
  font-weight: 700;
}

.hero .primary-btn {
  color: #ffffff;
  background: linear-gradient(180deg, #3dff8a 0%, #0ea76f 100%);
  box-shadow: 0 8px 24px rgba(14, 167, 111, 0.35);
}

.secondary-btn {
  color: #ffffff;
  border: 1.5px solid rgba(74, 222, 128, 0.55);
  background: transparent;
}

.trust-box {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  margin-top: 36px;
  max-width: 720px;
  border: 1px solid rgba(125, 255, 179, 0.18);
  border-radius: 10px;
  background: rgba(5, 30, 26, 0.55);
  backdrop-filter: blur(8px);

  .trust-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 20px 16px;
    border-right: 1px solid rgba(255, 255, 255, 0.14);
    text-align: left;
  }

  .trust-item:last-child {
    border-right: 0;
  }

  .trust-icon {
    flex-shrink: 0;
    line-height: 0;
  }

  .trust-text strong {
    display: block;
    font-size: var(--hero-trust-title);
    font-weight: 700;
  }

  .trust-text small {
    display: block;
    margin-top: 4px;
    font-size: var(--hero-trust-desc);
    font-weight: 400;
    opacity: 0.65;
    white-space: nowrap;
  }
}

.hero-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  background:#fff;
  border-radius: 36px;
}

.hero-visual-img {
  width: min(100%, 480px);
  height: auto;
  object-fit: contain;
  filter:
    drop-shadow(0 16px 40px rgba(0, 0, 0, 0.38))
    drop-shadow(0 4px 16px rgba(14, 167, 111, 0.15));
}

.feature-highlights,
.features-grid,
.step-grid,
.toc-grid,
.test-grid {
  display: grid;
  gap: 16px;
}

.toc-panel {
  display: none;
  margin: 22px 0;
  padding: 22px;
  border: 1px solid rgba(10, 111, 77, 0.12);
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(7, 86, 63, 0.08);

  .panel-title {
    margin: 0 0 14px;
    color: #073f32;
    font-size: 24px;
    font-weight: 900;
  }
}

.toc-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));

  a {
    padding: 12px 14px;
    border-radius: 8px;
    background: #effaf5;
    color: #096343;
    text-decoration: none;
    font-weight: 800;
  }
}

.test-results {
  display: none;
}

.test-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));

  article {
    padding: 18px;
    border-radius: 8px;
    background: #effaf5;
  }

  span {
    display: block;
    margin-bottom: 8px;
    color: #66867d;
    font-weight: 800;
  }

  strong {
    display: block;
    color: #073f32;
    font-size: 20px;
  }
}

.test-note {
  margin-top: 16px;
}

.feature-highlights {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  width: calc(100% + 16px);
  margin: 22px -8px;
}

.feature-highlights article,
.section-panel,
.features-grid article,
.step-grid article {
  border: 1px solid rgba(10, 111, 77, 0.12);
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(7, 86, 63, 0.08);
}

.feature-highlights article {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 16px 12px;
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 32px rgba(7, 86, 63, 0.12);
  }
}

.feature-highlights .highlight-icon {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: #e8f7ef;
  line-height: 0;
}

.feature-highlights .highlight-body {
  flex: 1;
  min-width: 0;
}

.feature-highlights .highlight-title {
  display: block;
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 700;
  color: #071d16;
}

.feature-highlights p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #3e665c;
}

.section-panel p,
.section-panel li {
  color: #3e665c;
  line-height: 1.75;
  font-size: 16px;
}

.section-panel a,
.test-note a {
  color: #07865a;
  font-weight: 900;
  text-decoration: none;
}

.section-panel {
  width: 100%;
  box-sizing: border-box;
  margin-top: 22px;
  padding: 28px;
}

.app-info {
  display: none;
  position: relative;
  overflow: hidden;
  padding: 48px 40px;
  background:
    radial-gradient(circle at 72% 8%, rgba(61, 255, 140, 0.16), transparent 26%),
    linear-gradient(135deg, #051610 0%, #063d33 54%, #082a24 100%);
  color: #ffffff;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(80, 230, 125, 0.14) 1px, transparent 1px);
    background-size: 22px 22px;
    opacity: 0.3;
    mask-image: linear-gradient(135deg, transparent 50%, black 90%);
    pointer-events: none;
  }

  .section-head p,
  p {
    color: rgba(255, 255, 255, 0.82);
  }

  h2 {
    color: #ffffff;
    font-size: 52px;
    line-height: 1.08;
    font-weight: 800;
  }
}

.app-info-watermark {
  position: absolute;
  right: 4%;
  top: 8%;
  width: 180px;
  height: 180px;
  opacity: 0.08;
  pointer-events: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' fill='none'%3E%3Cpath d='M32 4L54 14v16c0 14-9.5 24.5-22 28C19.5 54.5 10 44 10 30V14L32 4z' stroke='%234ade80' stroke-width='2' fill='%234ade80'/%3E%3Cpath d='M24 32l5 5 11-11' stroke='%23051610' stroke-width='2.5' stroke-linecap='round'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
}

.info-badge {
  display: inline-flex;
  margin-bottom: 14px;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(74, 222, 128, 0.18);
  border: 1px solid rgba(74, 222, 128, 0.35);
  color: #4ade80;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.app-info .section-head p {
  font-size: 17px;
  line-height: 1.6;
  max-width: 680px;
}

.section-head {
  position: relative;
  z-index: 1;
  max-width: 760px;
  margin-bottom: 18px;
}

.section-panel h2,
.section-title {
  margin: 0 0 12px;
  color: #073f32;
  font-size: 34px;
  line-height: 1.12;
  font-weight: 900;
}

.section-panel h3 {
  color: #0a6047;
}

.info-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.info-cell {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-height: 108px;
  padding: 22px 18px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(152, 255, 198, 0.12);
}

.info-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(74, 222, 128, 0.1);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 22px 22px;
}

.icon-phone .info-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Crect x='7' y='2' width='10' height='20' rx='2' stroke='%234ade80' stroke-width='1.5'/%3E%3Ccircle cx='12' cy='18' r='1' fill='%234ade80'/%3E%3C/svg%3E");
}

.icon-box .info-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M12 2L3 7v10l9 5 9-5V7l-9-5z' stroke='%234ade80' stroke-width='1.5'/%3E%3Cpath d='M3 7l9 5 9-5M12 12v10' stroke='%234ade80' stroke-width='1.5'/%3E%3C/svg%3E");
}

.icon-android .info-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Crect x='5' y='6' width='14' height='14' rx='2' stroke='%234ade80' stroke-width='1.5'/%3E%3Cpath d='M9 6V4M15 6V4' stroke='%234ade80' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
}

.icon-download .info-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M12 3v10M12 13l4-4M12 13l-4-4M4 19h16' stroke='%234ade80' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
}

.icon-refresh .info-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M4 12a8 8 0 0114-5M20 12a8 8 0 01-14 5' stroke='%234ade80' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M18 4v4h-4M6 20v-4h4' stroke='%234ade80' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
}

.icon-warning .info-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M12 3L2 21h20L12 3z' stroke='%234ade80' stroke-width='1.5'/%3E%3Cpath d='M12 10v4M12 17h.01' stroke='%234ade80' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
}

.icon-star .info-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M12 2l3 7h7l-5.5 4.5 2 7L12 17l-6.5 3.5 2-7L2 9h7l3-7z' stroke='%234ade80' stroke-width='1.5'/%3E%3C/svg%3E");
}

.info-line {
  margin-bottom: 6px;
}

.info-label {
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  margin-right: 4px;
}

.info-cell strong {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
}

.info-desc {
  margin: 0;
  color: rgba(255, 255, 255, 0.68);
  font-size: 13px;
  line-height: 1.5;
}

.wide .info-line strong {
  font-size: 16px;
}

.wide {
  grid-column: 1 / -1;
}

.features-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));

  article {
    padding: 18px;
  }

  .feature-card-title {
    margin-top: 0;
  }
}

#key-features {
  padding: 48px 40px;
  background:
    radial-gradient(circle at 50% 0%, rgba(47, 239, 127, 0.14), transparent 30%),
    linear-gradient(135deg, #041f1b 0%, #063b31 100%);

  .section-head {
    max-width: none;
    text-align: center;
    margin-bottom: 28px;
  }

  h2 {
    color: #ffffff;
    font-size: 44px;
    line-height: 1.1;
    font-weight: 800;

    .brand-green {
      color: #4ade80;
    }
  }

  .section-head p {
    max-width: 720px;
    margin: 0 auto;
    color: rgba(255, 255, 255, 0.78);
    font-size: 16px;
    line-height: 1.6;
  }

  .features-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
  }

  .features-grid article {
    min-height: 200px;
    padding: 20px 18px;
    border: 1px solid rgba(80, 230, 125, 0.18);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.04);
    box-shadow: none;
    text-align: left;
  }

  .feature-card-icon {
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    margin-bottom: 14px;
    border-radius: 10px;
    background: linear-gradient(135deg, #34f08a 0%, #0ea76f 100%);
    line-height: 0;
    box-shadow: 0 6px 16px rgba(14, 167, 111, 0.25);
  }

  .feature-card-title {
    display: block;
    margin: 0 0 10px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
  }

  .features-grid p {
    margin: 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: 13px;
    line-height: 1.55;
  }
}

.features-badge {
  display: inline-flex;
  margin-bottom: 14px;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(74, 222, 128, 0.15);
  border: 1px solid rgba(74, 222, 128, 0.35);
  color: #4ade80;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.steps {
  text-align: center;
  padding: 42px 28px;
  background: linear-gradient(180deg, #f8fffb 0%, #ffffff 100%);

  .install-badge {
    display: inline-flex;
    margin-bottom: 14px;
    padding: 5px 14px;
    border-radius: 999px;
    background: rgba(74, 222, 128, 0.15);
    border: 1px solid rgba(74, 222, 128, 0.35);
    color: #16a34a;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
  }

  > h2 {
    margin: 0 0 12px;
    color: #071d16;
    font-size: 36px;
    font-weight: 800;

    .brand-green {
      color: #22c55e;
    }
  }

  > p {
    max-width: 780px;
    margin: 0 auto 32px;
    color: #3e665c;
    font-size: 16px;
    line-height: 1.65;
  }
}

.install-flow {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 24px;
}

.install-step-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 320px;
  padding: 18px 14px 16px;
  border: 1px solid rgba(10, 111, 77, 0.1);
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(7, 86, 63, 0.08);
  text-align: center;

  .step-no {
    position: absolute;
    top: 14px;
    left: 14px;
    width: 34px;
    height: 34px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    color: #ffffff;
    background: linear-gradient(135deg, #34f08a, #0ea76f);
    font-size: 12px;
    font-weight: 800;
  }

  .step-icon {
    width: 88px;
    height: 88px;
    display: grid;
    place-items: center;
    margin: 24px 0 14px;
    border-radius: 50%;
    background: radial-gradient(circle, #dcfce7 0%, #f0fdf4 45%, rgba(240, 253, 244, 0.2) 72%);
    box-shadow: inset 0 0 0 1px rgba(34, 197, 94, 0.12);
    line-height: 0;

    img {
      width: 52px;
      height: 52px;
      object-fit: contain;
      filter: drop-shadow(0 6px 12px rgba(14, 167, 111, 0.22));
    }
  }

  h3 {
    margin: 0 0 10px;
    color: #071d16;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
  }

  p {
    flex: 1;
    margin: 0 0 14px;
    color: #5a736b;
    font-size: 12px;
    line-height: 1.55;
  }

  .step-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: auto;
    padding: 6px 10px;
    border-radius: 999px;
    background: #f0faf5;
    color: #0a6047;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
  }

  .step-tag-img {
    flex-shrink: 0;
    object-fit: contain;
  }

  .step-arrow {
    position: absolute;
    top: 50%;
    right: -10px;
    z-index: 2;
    transform: translateY(-50%);
    color: #34f08a;
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
  }
}

.install-tips {
  display: grid;
  grid-template-columns: minmax(240px, 0.9fr) minmax(0, 2.1fr);
  gap: 0;
  padding: 24px 28px;
  border: 1px solid rgba(10, 111, 77, 0.1);
  border-radius: 14px;
  background: #f3faf7;
  text-align: left;
}

.tips-intro {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-right: 24px;
  border-right: 1px solid rgba(10, 111, 77, 0.12);

  h3 {
    margin: 0 0 8px;
    color: #071d16;
    font-size: 18px;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: #5a736b;
    font-size: 13px;
    line-height: 1.55;
  }
}

.tips-shield {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: radial-gradient(circle, #dcfce7 0%, #f0fdf4 70%);
  box-shadow: 0 6px 16px rgba(14, 167, 111, 0.18);

  img {
    width: 44px;
    height: 44px;
    object-fit: contain;
  }
}

.tips-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
}

.tips-item {
  padding: 0 18px;
  border-right: 1px solid rgba(10, 111, 77, 0.1);

  &:last-child {
    border-right: 0;
  }

  .tips-item-icon {
    margin-bottom: 10px;
    line-height: 0;

    img {
      width: 28px;
      height: 28px;
      object-fit: contain;
      filter: drop-shadow(0 3px 8px rgba(14, 167, 111, 0.2));
    }
  }

  h4 {
    margin: 0 0 8px;
    color: #071d16;
    font-size: 14px;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: #5a736b;
    font-size: 12px;
    line-height: 1.5;
  }
}

.prose {
  blockquote {
    margin: 18px 0;
    padding: 18px;
    border-left: 4px solid #0ea76f;
    background: #effaf5;
    border-radius: 12px;
  }
}

/* 首页 5 个教程 prose 区块 — 与 Install / Tutorials Hub 风格统一 */
#backup-restore,
#transfer-data,
#fix-verification,
#avoid-ban,
#download-install + .section-panel.prose {
  padding: 40px 32px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fffb 0%, #ffffff 55%, #f4fbf7 100%);
  border: 1px solid rgba(16, 125, 92, 0.12);
  box-shadow: 0 12px 32px rgba(7, 86, 63, 0.07);

  h2 {
    margin: 0 0 14px;
    color: #071d16;
    font-size: 34px;
    font-weight: 800;
    line-height: 1.15;
  }

  > h2 + p {
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(16, 125, 92, 0.1);
    font-size: 16px;
    color: #4b6b62;
    line-height: 1.65;
  }

  h3 {
    margin: 22px 0 10px;
    padding: 10px 14px;
    border-left: 4px solid #16a34a;
    border-radius: 0 10px 10px 0;
    background: linear-gradient(90deg, #effaf5 0%, #ffffff 100%);
    font-size: 17px;
    font-weight: 800;
    color: #071d16;
    line-height: 1.35;
  }

  p {
    margin: 0 0 12px;
    font-size: 15px;
    color: #3e665c;
    line-height: 1.7;
  }

  strong {
    color: #065f46;
  }

  ul {
    margin: 12px 0 20px !important;
    padding-left: 0 !important;
    list-style: none !important;
    list-style-type: none !important;
  }

  li {
    position: relative;
    padding-left: 18px;
    margin-bottom: 8px;
    color: #3e665c;
    font-size: 15px;
    line-height: 1.7;
    list-style: none !important;
    list-style-type: none !important;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 10px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #16a34a;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.step-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));

  article {
    padding: 20px;
  }

  span {
    color: #0ea76f;
    font-weight: 900;
  }
}

/* Tutorials & Guides Hub — 对齐设计稿 */
.tutorials-hub {
  padding: 42px 32px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f4fff8 0%, #e8fff3 55%, #f0fff6 100%);
}

.tutorials-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  gap: 24px;
  align-items: center;
  margin-bottom: 32px;
}

.tutorials-title-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 22px;

  h2 {
    margin: 0 0 8px;
    color: #071d16;
    font-size: 34px;
    font-weight: 800;
    line-height: 1.15;
  }

  p {
    margin: 0;
    max-width: 620px;
    color: #4b6b62;
    font-size: 15px;
    line-height: 1.65;
  }
}

.tutorials-book-badge {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border-radius: 14px;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  box-shadow: 0 8px 20px rgba(22, 163, 74, 0.28);

  svg {
    width: 26px;
    height: 26px;
  }
}

.tutorials-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  padding: 16px 20px;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(7, 86, 63, 0.08);
}

.tutorials-stat {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 0 16px;
  border-right: 1px solid rgba(10, 111, 77, 0.1);

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
    border-right: 0;
  }

  strong {
    display: block;
    color: #071d16;
    font-size: 14px;
    font-weight: 800;
    line-height: 1.3;
  }

  small {
    display: block;
    margin-top: 2px;
    color: #6b8a80;
    font-size: 12px;
    line-height: 1.35;
  }
}

.tutorials-stat-icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: rgba(34, 197, 94, 0.12);

  svg {
    width: 22px;
    height: 22px;
  }
}

.tutorials-hero-art {
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: min(100%, 200px);
    height: auto;
    filter: drop-shadow(0 12px 24px rgba(22, 163, 74, 0.18));
  }
}

.tutorials-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 28px;
}

.tutorials-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 220px;
  padding: 28px 22px 22px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(15, 78, 59, 0.08);
  color: #143f35;
  text-align: center;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 40px rgba(15, 78, 59, 0.14);
  }

  strong {
    display: block;
    margin-bottom: 8px;
    color: #071d16;
    font-size: 17px;
    font-weight: 800;
  }

  span {
    flex: 1;
    color: #5a7a70;
    font-size: 14px;
    line-height: 1.6;
  }

  em {
    display: block;
    margin-top: 16px;
    color: #16a34a;
    font-style: normal;
    font-size: 14px;
    font-weight: 800;
  }
}

.tutorials-card-icon {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  margin-bottom: 16px;
  border-radius: 16px;

  img {
    width: 32px;
    height: 32px;
  }
}

.tutorials-card.theme-install .tutorials-card-icon { background: #ecfdf5; }
.tutorials-card.theme-update .tutorials-card-icon { background: #eff6ff; }
.tutorials-card.theme-backup .tutorials-card-icon { background: #faf5ff; }
.tutorials-card.theme-transfer .tutorials-card-icon { background: #fffbeb; }
.tutorials-card.theme-verify .tutorials-card-icon { background: #fef2f2; }
.tutorials-card.theme-ban .tutorials-card-icon { background: #f0fdfa; }

.tutorials-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  padding: 16px 28px;
  border-radius: 999px;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  box-shadow: 0 12px 28px rgba(22, 163, 74, 0.32);
  color: #ffffff;
  font-size: 16px;
  font-weight: 800;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 34px rgba(22, 163, 74, 0.38);
  }
}

#safety {
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

/* Is GB WhatsApp Safe — 对齐设计稿 */
.safety-section {
  display: grid;
  gap: 22px;
}

.safety-hero {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr) 220px;
  gap: 24px;
  align-items: center;
  padding: 32px 28px;
  border-radius: 18px;
  background: linear-gradient(135deg, #f0fff6 0%, #e8fff3 45%, #f8fffb 100%);
  box-shadow: 0 14px 36px rgba(7, 86, 63, 0.08);
}

.safety-hero-shield {
  width: 72px;
  height: 72px;
  display: grid;
  place-items: center;
  border-radius: 18px;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  box-shadow: 0 10px 24px rgba(22, 163, 74, 0.28);

  svg {
    width: 44px;
    height: 44px;
  }
}

.safety-hero-copy {
  h2 {
    margin: 0 0 10px;
    color: #071d16;
    font-size: 34px;
    font-weight: 800;
    line-height: 1.15;

    .brand-green {
      color: #16a34a;
    }
  }

  > p {
    margin: 0 0 16px;
    max-width: 640px;
    color: #4b6b62;
    font-size: 15px;
    line-height: 1.65;
  }
}

.safety-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.safety-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border: 1px solid rgba(22, 163, 74, 0.28);
  border-radius: 999px;
  background: #ffffff;
  color: #166534;
  font-size: 13px;
  font-weight: 700;
}

.safety-tag-icon {
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;

  svg {
    width: 16px;
    height: 16px;
  }
}

.safety-hero-art {
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: min(100%, 220px);
    height: auto;
    filter: drop-shadow(0 12px 24px rgba(22, 163, 74, 0.16));
  }
}

.safety-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.safety-card {
  padding: 24px 22px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(15, 78, 59, 0.08);

  h3 {
    margin: 0 0 12px;
    color: #071d16;
    font-size: 18px;
    font-weight: 800;
  }

  p {
    margin: 0 0 10px;
    color: #5a7a70;
    font-size: 14px;
    line-height: 1.65;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    position: relative;
    padding-left: 16px;
    margin-bottom: 8px;
    color: #5a7a70;
    font-size: 14px;
    line-height: 1.55;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 8px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #f97316;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.safety-card-icon {
  width: 52px;
  height: 52px;
  display: grid;
  place-items: center;
  margin-bottom: 14px;
  border-radius: 14px;

  svg {
    width: 28px;
    height: 28px;
  }
}

.safety-card.theme-security .safety-card-icon { background: #ecfdf5; }
.safety-card.theme-risks .safety-card-icon { background: #fff7ed; }
.safety-card.theme-users .safety-card-icon { background: #eff6ff; }

.safety-conclusion {
  position: relative;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 18px;
  align-items: center;
  padding: 22px 24px 22px 20px;
  border-left: 5px solid #16a34a;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(15, 78, 59, 0.08);
  overflow: hidden;
}

.safety-conclusion-check {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  box-shadow: 0 8px 18px rgba(22, 163, 74, 0.28);

  svg {
    width: 22px;
    height: 22px;
  }
}

.safety-conclusion-copy {
  h3 {
    margin: 0 0 8px;
    color: #071d16;
    font-size: 18px;
    font-weight: 800;
  }

  p {
    margin: 0;
    color: #5a7a70;
    font-size: 14px;
    line-height: 1.65;
  }

  strong {
    color: #071d16;
  }
}

.safety-conclusion-watermark {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;

  svg {
    width: 80px;
    height: 88px;
  }
}

/* Pros and Cons — 对齐设计稿 */
.pros-cons-section {
  padding: 42px 32px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 14px 36px rgba(7, 86, 63, 0.06);
  text-align: center;
}

.pros-cons-header {
  max-width: 760px;
  margin: 0 auto 28px;

  h2 {
    margin: 0 0 12px;
    color: #071d16;
    font-size: 36px;
    font-weight: 800;
    line-height: 1.2;

    .brand-green {
      color: #16a34a;
    }
  }

  p {
    margin: 0;
    color: #5a7a70;
    font-size: 16px;
    line-height: 1.65;
  }
}

.pros-cons-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 28px;
}

.pros-cons-stat {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 78, 59, 0.08);
  text-align: left;

  p {
    margin: 0;
    color: #374151;
    font-size: 14px;
    line-height: 1.45;

    strong {
      color: #071d16;
      font-weight: 800;
    }
  }
}

.pros-cons-stat-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 50%;

  svg {
    width: 22px;
    height: 22px;
  }
}

.pros-cons-stat.theme-downloads .pros-cons-stat-icon {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}

.pros-cons-stat.theme-privacy .pros-cons-stat-icon {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}

.pros-cons-stat.theme-warning .pros-cons-stat-icon {
  background: linear-gradient(135deg, #fb923c, #ea580c);
}

.pros-cons-compare {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 0;
  align-items: stretch;
  margin-bottom: 24px;
}

.pros-panel,
.cons-panel {
  position: relative;
  padding: 28px 24px 24px;
  border-radius: 16px;
  text-align: left;

  h3 {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 18px 0 20px;
    font-size: 22px;
    font-weight: 800;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    display: grid;
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 14px;
    align-items: start;
    margin-bottom: 18px;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      display: block;
      margin-bottom: 4px;
      color: #071d16;
      font-size: 15px;
      font-weight: 800;
    }

    p {
      margin: 0;
      color: #6b7280;
      font-size: 13px;
      line-height: 1.55;
    }
  }
}

.pros-panel {
  border: 2px solid rgba(34, 197, 94, 0.45);
  background: linear-gradient(180deg, #f8fffb 0%, #ffffff 100%);

  h3 {
    color: #15803d;
  }
}

.cons-panel {
  border: 2px solid rgba(239, 68, 68, 0.4);
  background: linear-gradient(180deg, #fff8f8 0%, #ffffff 100%);

  h3 {
    color: #b91c1c;
  }
}

.pros-cons-badge {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.badge-pros {
  background: rgba(34, 197, 94, 0.12);
  color: #15803d;
}

.badge-cons {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
}

.pros-cons-heading-icon {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 900;
}

.badge-pros-icon {
  background: #22c55e;
  color: #ffffff;
}

.badge-cons-icon {
  background: #ef4444;
  color: #ffffff;
}

.pros-cons-item-icon {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 12px;

  svg {
    width: 20px;
    height: 20px;
  }
}

.pros-icon {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}

.cons-icon {
  background: linear-gradient(135deg, #f87171, #ef4444);
}

.pros-cons-vs {
  position: relative;
  z-index: 2;
  align-self: center;
  width: 58px;
  height: 58px;
  margin: 0 -12px;
  display: grid;
  place-items: center;
  border: 2px solid #e5e7eb;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);

  span {
    color: #111827;
    font-size: 16px;
    font-weight: 900;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 18px;
    height: 2px;
    transform: translateY(-50%);
  }

  &::before {
    right: 100%;
    margin-right: 6px;
    background: linear-gradient(90deg, #22c55e, #e5e7eb);
  }

  &::after {
    left: 100%;
    margin-left: 6px;
    background: linear-gradient(90deg, #e5e7eb, #ef4444);
  }
}

.pros-cons-verdict {
  position: relative;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) 120px;
  gap: 18px;
  align-items: center;
  padding: 22px 24px;
  border: 1px solid rgba(59, 130, 246, 0.25);
  border-radius: 16px;
  background: linear-gradient(135deg, #f0f7ff 0%, #f8fbff 100%);
  text-align: left;
  overflow: hidden;
}

.pros-cons-verdict-icon {
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.28);

  svg {
    width: 24px;
    height: 24px;
  }
}

.pros-cons-verdict-copy {
  h3 {
    margin: 0 0 6px;
    color: #1d4ed8;
    font-size: 18px;
    font-weight: 800;
  }

  p {
    margin: 0;
    color: #4b5563;
    font-size: 14px;
    line-height: 1.65;
  }
}

.pros-cons-verdict-art {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  svg {
    width: 100px;
    height: auto;
  }
}

.faq details {
  border-top: 1px solid rgba(10, 111, 77, 0.12);
  padding: 14px 0;
}

.faq summary {
  cursor: pointer;
  color: #073f32;
  font-weight: 900;
}

.final-cta-card {
  position: relative;
  width: 100%;
  max-width: 1120px;
  margin: 24px auto 0;
  padding: 36px 40px;
  border-radius: 28px;
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr) auto;
  gap: 32px;
  align-items: center;
  overflow: hidden;
  background: linear-gradient(135deg, #031612 0%, #052018 35%, #0a3326 70%, #052018 100%);
  color: #ffffff;
  box-shadow: 0 20px 48px rgba(3, 22, 18, 0.35);
}

.final-cta-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.final-cta-glow {
  position: absolute;
  left: 28px;
  top: 50%;
  width: 180px;
  height: 180px;
  transform: translateY(-50%);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(61, 255, 138, 0.22) 0%, rgba(61, 255, 138, 0) 70%);
}

.final-cta-orbit {
  position: absolute;
  right: 18%;
  top: 50%;
  width: 320px;
  height: 320px;
  transform: translateY(-50%);
  border: 1px solid rgba(74, 222, 128, 0.12);
  border-radius: 50%;
  box-shadow:
    0 0 0 28px rgba(74, 222, 128, 0.04),
    0 0 0 56px rgba(74, 222, 128, 0.03);
}

.final-cta-logo-wrap {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 112px;
    height: 112px;
    object-fit: contain;
    border-radius: 24px;
    filter:
      drop-shadow(0 0 24px rgba(61, 255, 138, 0.45))
      drop-shadow(0 12px 28px rgba(0, 0, 0, 0.35));
  }
}

.final-cta-copy {
  position: relative;
  z-index: 1;
  text-align: left;

  h2 {
    margin: 0 0 10px;
    color: #ffffff;
    font-size: 30px;
    font-weight: 800;
    line-height: 1.2;
  }

  > p {
    margin: 0 0 18px;
    max-width: 520px;
    color: rgba(255, 255, 255, 0.88);
    font-size: 15px;
    line-height: 1.65;
  }
}

.final-cta-features {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
}

.final-cta-feature {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 13px;
  font-weight: 700;

  &:first-child {
    padding-left: 0;
  }

  &:not(:first-child) {
    border-left: 1px solid rgba(255, 255, 255, 0.18);
  }
}

.final-cta-feature-icon {
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;

  svg {
    width: 18px;
    height: 18px;
  }
}

.final-cta-action {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.final-cta-btn {
  min-width: 260px;
  min-height: 56px;
  padding: 0 28px;
  border-radius: 999px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 800;
  text-decoration: none;
  background: linear-gradient(180deg, #3dff8a 0%, #22c55e 45%, #16a34a 100%);
  box-shadow:
    0 10px 28px rgba(34, 197, 94, 0.38),
    0 0 0 1px rgba(255, 255, 255, 0.08) inset;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow:
      0 14px 34px rgba(34, 197, 94, 0.45),
      0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  }
}

.final-cta-version {
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;

  strong {
    color: #4ade80;
    font-weight: 800;
  }
}

@media (max-width: 1100px) and (min-width: 921px) {
  #key-features .features-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .install-flow {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  .install-step-card .step-arrow {
    display: none;
  }

  .tutorials-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 920px) {
  .hero {
    grid-template-columns: 1fr;
    min-height: 0;
    padding: 30px 20px;
    --hero-h1-size: 42px;
    --hero-sub-size: 18px;
    --hero-check-size: 14px;
    --hero-btn-size: 15px;
    --hero-trust-title: 14px;
    --hero-trust-desc: 11px;
  }

  .hero h1 {
    font-size: var(--hero-h1-size);
  }

  .subheading {
    font-size: var(--hero-sub-size);
  }

  .hero-checks {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin: 24px 0 24px;
  }

  .hero-checks span {
    white-space: normal;
  }

  .hero-actions .primary-btn,
  .hero-actions .secondary-btn {
    min-height: 50px;
    flex: 1 1 auto;
  }

  .hero-visual-img {
    max-width: 360px;
  }

  .trust-box {
    grid-template-columns: 1fr;
  }

  .trust-box .trust-item {
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.14);
  }

  .trust-box .trust-item:last-child {
    border-bottom: 0;
  }

  .feature-highlights {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  .features-grid,
  .step-grid,
  .info-grid,
  .toc-grid,
  .test-grid {
    grid-template-columns: 1fr;
  }

  #key-features .features-grid {
    grid-template-columns: 1fr;
  }

  .install-flow {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .install-step-card {
    min-height: 0;

    .step-arrow {
      display: none;
    }
  }

  .install-tips {
    grid-template-columns: 1fr;
    padding: 20px 18px;
  }

  .tips-intro {
    padding-right: 0;
    padding-bottom: 18px;
    margin-bottom: 18px;
    border-right: 0;
    border-bottom: 1px solid rgba(10, 111, 77, 0.12);
  }

  .tips-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .tips-item {
    padding: 0 0 14px;
    border-right: 0;
    border-bottom: 1px solid rgba(10, 111, 77, 0.08);

    &:last-child {
      padding-bottom: 0;
      border-bottom: 0;
    }
  }

  .steps {
    padding: 28px 20px;

    > h2 {
      font-size: 28px;
    }
  }

  #backup-restore,
  #transfer-data,
  #fix-verification,
  #avoid-ban,
  #download-install + .section-panel.prose {
    padding: 24px 18px;

    h2 {
      font-size: 28px;
    }

    h3 {
      font-size: 16px;
      padding: 9px 12px;
    }

    p,
    li {
      font-size: 14px;
    }

    > h2 + p {
      font-size: 15px;
    }
  }

  .tutorials-hub {
    padding: 28px 20px;
  }

  .tutorials-header {
    grid-template-columns: 1fr;
  }

  .tutorials-hero-art {
    order: -1;
  }

  .tutorials-title-row h2 {
    font-size: 28px;
  }

  .tutorials-stats {
    grid-template-columns: 1fr;
    gap: 14px;
    padding: 16px;
  }

  .tutorials-stat {
    padding: 0 0 14px;
    border-right: 0;
    border-bottom: 1px solid rgba(10, 111, 77, 0.1);

    &:last-child {
      padding-bottom: 0;
      border-bottom: 0;
    }
  }

  .tutorials-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .tutorials-card {
    min-height: 0;
    padding: 22px 18px 18px;
  }

  .safety-hero {
    grid-template-columns: 1fr;
    padding: 24px 20px;
  }

  .safety-hero-shield {
    width: 56px;
    height: 56px;

    svg {
      width: 34px;
      height: 34px;
    }
  }

  .safety-hero-copy h2 {
    font-size: 28px;
  }

  .safety-hero-art {
    justify-content: flex-start;
  }

  .safety-cards {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .safety-conclusion {
    grid-template-columns: auto minmax(0, 1fr);
    padding: 18px 18px 18px 16px;
  }

  .safety-conclusion-watermark {
    opacity: 0.5;
    right: 12px;
  }

  .pros-cons-section {
    padding: 28px 20px;
  }

  .pros-cons-header h2 {
    font-size: 28px;
  }

  .pros-cons-stats {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .pros-cons-compare {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .pros-cons-vs {
    margin: 0 auto;

    &::before,
    &::after {
      display: none;
    }
  }

  .pros-panel,
  .cons-panel {
    padding: 22px 18px 18px;
  }

  .pros-cons-verdict {
    grid-template-columns: auto minmax(0, 1fr);
    padding: 18px;
  }

  .pros-cons-verdict-art {
    display: none;
  }

  #key-features h2 {
    font-size: 32px;
  }

  .app-info {
    display: block;
    padding: 28px 20px;
  }

  #key-features {
    padding: 28px 20px;
  }

  .app-info h2 {
    font-size: 36px;
  }

  .info-cell {
    min-height: 0;
  }

  .final-cta-card {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 28px 24px;
    text-align: center;
  }

  .page-closing {
    max-width: 100%;
  }

  .final-cta-copy {
    text-align: center;

    > p {
      margin-left: auto;
      margin-right: auto;
    }
  }

  .final-cta-features {
    justify-content: center;
  }

  .final-cta-logo-wrap img {
    margin: 0 auto;
  }

  .final-cta-orbit {
    right: 50%;
    transform: translate(50%, -50%);
    width: 240px;
    height: 240px;
  }
}
</style>
